import React from "react";
import { Switch, Route } from "react-router-dom";

import UsersPage from "./UsersPage";
import UserPage from "./UserPage";

const UserRouter = () => (
  <Switch>
    <Route path="/admin/users/:id">
      <UserPage />
    </Route>
    <Route path="/admin/users">
      <UsersPage />
    </Route>
  </Switch>
);

export default UserRouter;
